import React, { Component } from 'react';
import './ErrorBoundary.css';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
            error: null,
        };
    }

    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error,
        };
    }

    componentDidCatch(error, errorInfo) {
        // Keep the error visible to developers.
        // A production monitoring service can be added later.
        console.error(
            'ErrorBoundary caught an error:',
            error,
            errorInfo
        );
    }

    componentDidUpdate(previousProps) {
        const resetKeyChanged =
            previousProps.resetKey !== this.props.resetKey;

        if (
            this.state.hasError &&
            resetKeyChanged
        ) {
            this.resetBoundary();
        }
    }

    resetBoundary = () => {
        this.setState({
            hasError: false,
            error: null,
        });
    };

    reloadPage = () => {
        window.location.reload();
    };

    render() {
        if (!this.state.hasError) {
            return this.props.children;
        }

        return (
            <div
                className="error-boundary"
                role="alert"
                aria-live="assertive"
            >
                <div className="error-boundary-content">
                    <h2 className="title text-primary">
                        Something went wrong
                    </h2>

                    <p className="text-grey">
                        We could not display this page.
                        Please try again or reload the application.
                    </p>

                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            gap: '12px',
                        }}
                    >
                        <button
                            type="button"
                            className="refresh-button"
                            onClick={this.resetBoundary}
                        >
                            Try Again
                        </button>

                        <button
                            type="button"
                            className="refresh-button"
                            onClick={this.reloadPage}
                        >
                            Reload Page
                        </button>
                    </div>

                    {process.env.NODE_ENV === 'development' &&
                        this.state.error && (
                            <details
                                style={{
                                    marginTop: '20px',
                                    whiteSpace: 'pre-wrap',
                                    textAlign: 'left',
                                }}
                            >
                                <summary>
                                    Development error details
                                </summary>

                                <pre>
                                    {this.state.error.toString()}
                                </pre>
                            </details>
                        )}
                </div>
            </div>
        );
    }
}

export default ErrorBoundary;